projectFunctions.productMobileSliderFunctions = projectFunctions.productMobileSliderFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.productMobileSliderFunctions.init = function() {
    this.mobileSlider();
};

projectFunctions.productMobileSliderFunctions.mobileSlider = function () {
    const productMobileSliders = $('.product-mobile-slider');

    if (!productMobileSliders) {
      return;
    }
  
    productMobileSliders.each(function () {
      $(this).slick({
        infinite: true, // Only infinite if slides are more than `slidesToShow`,
        dots: false,
        speed: 500,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: false,
        variableWidth: false,
        draggable: true, // Ensure dragging is enabled
        prevArrow: '<button class="slick_btn btn_prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#000"/></svg></button>',
        nextArrow: '<button class="slick_btn btn_next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#000"/></svg></button>',
      });
    });
}